export const resetPassword = (axios) => ({
  sendResetPasswordEmail: (query) => {
    return new Promise((resolve, reject) =>
      axios.post('/api/reset_password', query).then(
        () => {
          resolve()
        },
        (error) => {
          reject(error)
        })
    )
  },
  resetPassword: (query) => {
    return new Promise((resolve, reject) =>
      axios.patch('/api/reset_password', query).then(
        () => {
          resolve()
        },
        (error) => {
          reject(error)
        })
    )
  }
})
